// Set the following to proper server URL,
// and rename this file to "quick_match_server_url.js".
export const serverURL = 'https://pikavolley-online.du.r.appspot.com/';
